// src/components/WinnerModal.js
import React, { useEffect } from 'react';

// Fungsi untuk membuat konfeti
const createConfetti = () => {
    const confettiContainer = document.body;
    const confettiPieces = [];
    for (let i = 0; i < 50; i++) {
        const confetti = document.createElement('div');
        confetti.className = 'confetti';
        confetti.style.left = Math.random() * 100 + 'vw';
        confetti.style.animationDelay = Math.random() * 2 + 's';
        confetti.style.animationDuration = (Math.random() * 3 + 2) + 's'; // Durasi bervariasi
        confetti.style.backgroundColor = `hsl(${Math.random() * 360}, 100%, 50%)`;
        confettiContainer.appendChild(confetti);
        confettiPieces.push(confetti);
    }
    return confettiPieces;
};

function WinnerModal({ winner, message, onPlayAgain }) {

    useEffect(() => {
        // Buat konfeti saat modal muncul
        const pieces = createConfetti();

        // Fungsi cleanup: Hapus konfeti saat modal ditutup (unmount)
        return () => {
            pieces.forEach(piece => piece.remove());
        };
    }, []); // Array dependensi kosong agar hanya berjalan sekali saat mount

    return (
        <div id="winnerModal" className="modal" style={{ display: 'flex' }}>
            <div className="modal-content">
                <h2 id="winnerText">
                    <span>🎉</span>
                    <span>{winner} Menang!</span>
                    <span>🎉</span>
                </h2>
                <p id="winnerMessage">{message}</p>
                <button className="play-again-btn" onClick={onPlayAgain}>
                    Main Lagi
                </button>
            </div>
        </div>
    );
}

export default WinnerModal;